import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from '@bibliocommons/heading';

import SyndeticsUnboundEnrichment from 'app/components/bibs/shared/SyndeticsUnboundEnrichment';
import VendorAttributionLabel from 'app/components/bibs/shared/VendorAttributionLabel';
import { getRecommendationProviderDisplayName } from 'app/helpers/bib/bibHelpers';
import syndeticsUnbound from 'app/utils/syndenticsUnbound';

const ReadingLevel = ({ isVisible }) => {
  return (
    <div className="cp-reading-level" style={{ display: isVisible ? 'block' : 'none' }}>
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage defaultMessage="Titles at a similar reading level" id="reading_level" />
      </Heading>
      <VendorAttributionLabel name={getRecommendationProviderDisplayName('SYNDETICS_UNBOUND')} />
      <SyndeticsUnboundEnrichment
        enrichmentId={syndeticsUnbound.SUPPORTED_ENRICHMENT_IDS.READING_LEVEL}
        hasTitle={false}
      />
    </div>
  );
};

ReadingLevel.propTypes = {
  isVisible: PropTypes.bool.isRequired
};

export default ReadingLevel;
